import { store } from '@utils/configStore'
import storeRecommendationReducer from './slices'

export const injectStoreRecommendationManagement = () => store.injectReducer('storeRecommendation', storeRecommendationReducer)
